export function taskHasTeam(task) {
  return Boolean(task?.teamId || task?.team?.id);
}

// Payload completo para updateTask cambiando solo fixedTeam (conserva el estado actual)
export function buildFixedTeamPayload(task, fixedTeam) {
  return {
    ...task,
    taskType: task?.taskType || task?.taskTypeId,
    teamId: task?.teamId || task?.team?.id || null,
    client: {
      ...(task?.client || {})
    },
    fixedTeam
  };
}
